export const previewColors = ["#B0B0B0", "#8B8B8B", "#E3E3E3"];
